export default __webpack_public_path__ + "static/media/profilePic.3b0904bf.jpg";